<template>
  <div class="page">
    <div class="ov" v-infinite-scroll="loads" infinite-scroll-immediate="false">
      <div class="items" v-for="(item, index) in xxlist" :key="index">
        <div class="flex_l">
          <img src="@/assets/icon.png" alt="" srcset="">
        </div>
        <div class="flex_r">
          <div class="titflex">
            <div class="t1">广材帮平台</div>
            <div class="t2"> {{ item.createtime | formatDate }}</div>
          </div>
          <!-- 类型:1=支付成功供应商,2=通知供应商发货,3=资料审核通知,4=通知供应商报价,5=发货通知客户,6=提供客户支付,7=已报价通知客户 -->
          <div class="message">
            <div> {{ item.message }}</div>
            <div class="btn" v-if="item.type == 3" @click="goback">查看店铺资料</div>
          </div>
        </div>
      </div>
      <div class="kongts1" v-if="nolist">
        <div>
          <img src="../../assets/tim/rightkong.png" alt="" srcset="">
          <div class="texts">
            暂无消息通知
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getNoticelist, getnotReadNum } from '@/api/index.js'
export default {
  name: '',
  data() {
    return {
      xxlist: [],
      nolist: false,
      queryParams: {
        page: 1,
        limit: 10,
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    getnotReadNum().then(ress => {
      if (ress.code == 1) {
        this.$store.commit('SetXtxiaonum', ress.data.num)
        this.loading = false
      }
    })
    this.getlist()
  },
  methods: {
    getlist() {
      getNoticelist(this.queryParams).then(res => {
        if (res.code == 1) {
          this.xxlist.push(...res.data.list)
          let total = Math.ceil(res.data.total / this.queryParams.limit);
          this.nolist = total == 0
        }
      })
    },
    loads() {
      this.queryParams.page++
      this.getlist()
    },
    goback() {
      this.$emit('goback', 1)
    }
  },
}
</script>
<style lang='scss' scoped>
.kongts1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 660px;
  text-align: center;
  width: 100%;

  img {
    width: 224px;
    height: 224px;
  }

  .texts {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    line-height: 46px;
  }
}

.page {
  padding: 20px 10px 20px 20px;
  width: 1110px;
  box-sizing: border-box;
}

.ov {
  height: 660px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
    border-radius: 4px;
  }
}

.items {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #DEDEDE;
  padding-bottom: 20px;
  margin-bottom: 20px;

  .flex_l {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #DEDEDE;


    img {
      width: 36px;
      height: 24px;
    }
  }

  .flex_r {
    margin-left: 13px;

    .titflex {
      display: flex;
      align-items: center;

      .t1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
      }

      .t2 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #ADAAAA;
        margin-left: 16px;
      }
    }

    .message {
      margin-top: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #666666;

      .btn {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #1DB4FF;
        line-height: 16px;
        margin-top: 6px;
        cursor: pointer;

      }
    }
  }
}
</style>